import { useEffect, useState } from "react";
import BreadCrumb from "../components/breadCrumb";
import DataGrid from "../components/common/DataGrid";
import { TextArea } from "../components/common/TextArea";
import { TextBox } from "../components/common/TextBox";
import PageContent from "../components/pageContent";
import PopupContent from "../components/popupContent";
import {
  apiCreateOrUpdatePigment,
  apiGetAllPigments,
  apiGetPigmentDetail,
} from "../services/PigmentsService";
import {
  apiGetSampleCardDetail,
  apiSampleCardCreateOrUpdate,
} from "../services/SampleCardsService";

import PopupOperationsBar from "./PopupOperationsBar";

import iconOdstiny from "../images/buttons/odstin.png";

import {
  apiColorCreateOrUpdate,
  apiGetColorDetail,
} from "../services/ColorsService";
// styles
require("./PopupGeneralStyles.css");

interface Props {
  id?: number;
  handleCancel: any;
  refreshData: any;
  products: any[];
}

const ColorProductsPopup = (props: Props) => {
  const [loading, setLoading] = useState(true);
  const data: any = {};
  const [formData, setFormData] = useState(data);
  const [saveError, setSaveError] = useState(false);

  useEffect(() => {
    if (props.id) {
      apiGetColorDetail(props.id).then((responseData) => {
        setFormData(responseData.data);

        setLoading(false);
      });
    } else {
      setLoading(false);
    }
  }, []);

  const onAddingClick = () => {
    setLoading(true);
    apiColorCreateOrUpdate(formData)
      .then((responseData) => {
        props.refreshData();
        props.handleCancel();

        setLoading(false);
      })
      .catch(() => {
        setSaveError(true);
      });
  };

  const onEditingClick = () => {
    setLoading(true);
    apiColorCreateOrUpdate(formData)
      .then((responseData) => {
        props.refreshData();
        props.handleCancel();

        setLoading(false);
      })
      .catch(() => {
        setSaveError(true);
      });
  };

  const onCancelClick = () => {
    props.handleCancel();
  };

  return (
    <PopupContent
      headerIcon={iconOdstiny}
      header={"Výběr produktu pro tónování"}
    >
      <>
        <div className="list-group">
          {props.products.map((product: any) => {
            return (
              <button
                type="button"
                className="list-group-item list-group-item-action"
              >
                {product.name}
              </button>
            );
          })}
        </div>
        <PopupOperationsBar
          handleAdding={onAddingClick}
          handleCancellation={onCancelClick}
          handleEditing={onEditingClick}
          addingText="Tónovat"
          id={props.id}
        />
      </>
    </PopupContent>
  );
};

export default ColorProductsPopup;
